import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OverlayHandler } from '@core/handler/overlay.handler';
import { OverlayDialog } from '../overlay-dialog/overlay-dialog.component';

@Component({
  selector: 'crm-overlay-page',
  imports: [],
  styleUrl: './overlay-page.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ``,
})
export class OverlayPage {
  protected readonly dialog = inject(MatDialog);
  protected readonly overlayHandler = inject(OverlayHandler);
  private dialogRef: MatDialogRef<OverlayDialog> | null = null;

  constructor() {
    effect(() => {
      const config = this.overlayHandler.dialog();
      if (config) {
        this.openDialog();
      } else if (this.dialogRef) {
        this.dialogRef.close();
        this.dialogRef = null;
      }
    });
  }

  openDialog() {
    this.dialogRef = this.dialog.open(OverlayDialog);
  }
}
